// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__ootoj","text":"logo_text__k4mNx"};